module.exports = __webpack_public_path__ + "img/ic_world.950458a6.svg";